export default "__VITE_ASSET__d0ee7a5f__"